'use client'

import { FC } from 'react'

import { nanoid } from 'nanoid'

import { HeaderProps } from '../../types'

const Header: FC<HeaderProps> = ({
  headerData,
  className,
  classNameHeader,
}) => {
  return (
    <>
      {headerData?.length ? (
        <div
          key={nanoid()}
          className={`grid gap-4 border border-grayscale-400 rounded my-4 p-2 prose-body ${className}`}
        >
          {headerData.map((header) => (
            <div key={nanoid()} className={classNameHeader}>
              {header}
            </div>
          ))}
        </div>
      ) : null}
    </>
  )
}

export default Header
